if (!customElements.get('product-subscribe')) {
  class ProductSubscribe extends HTMLElement {
    constructor() {
      super();

      this.handleChange = this.handleChange.bind(this);
    }

    handleSelect(select) {
      if (!select) return;

      const oneTime = this.querySelector('[js-one-time]');
      if (oneTime?.checked) return;

      if (!select.value && select.options.length) {
        select.value = select.options[0].value;
      }

      const skioSelect = document.querySelector('[name="selling_plan"]');
      if (!skioSelect) return;

      skioSelect.value = select.value;
      skioSelect.dispatchEvent(new Event('change', { bubbles: true }));
    }

    handleChange(event) {
      const select = this.querySelector('[js-plan-select]');
      if (!select) return;

      if (event.target.tagName === 'SELECT') return this.handleSelect(select);

      const subscribe = this.querySelector('[js-subscription]');
      const oneTime = this.querySelector('[js-one-time]');
      const url = new URL(window.location.href);
      const skioSubscribe = document.querySelector('[value="subscription"]');
      const skioOneTime = document.querySelector('[value="onetime"]');

      if (skioSubscribe) {
        skioSubscribe.checked = subscribe.checked;
        skioSubscribe.dispatchEvent(new Event('change', { bubbles: true }));
      }

      if (skioOneTime) {
        skioOneTime.checked = oneTime.checked;
        skioOneTime.dispatchEvent(new Event('change', { bubbles: true }));
      }

      if (oneTime.checked) {
        select.setAttribute('name', 'no_plan');
        url.searchParams.delete('selling_plan');
      } else {
        if (!select.value && select.options.length) {
          select.value = select.options[0].value;
        }

        select.setAttribute('name', 'selling_plan');
        url.searchParams.set('selling_plan', select.value);
        this.handleSelect(select);
      }

      window.history.replaceState({}, '', url.toString());
    }

    connectedCallback() {
      this.addEventListener('change', this.handleChange);

      const select = this.querySelector('[js-plan-select]');
      if (!select) return;

      const oneTime = this.querySelector('[js-one-time]');
      select.setAttribute('name', oneTime?.checked ? 'no_plan' : 'selling_plan');
    }
  }

  customElements.define('product-subscribe', ProductSubscribe);
}
